module.exports = __webpack_public_path__ + "img/economia.e7426ed6.png";